<template>
  <el-dialog title="认证信息" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-descriptions title="">
      <el-descriptions-item label="认证类型">{{info.certificatesType==1?'企业认证':'个人认证'}}</el-descriptions-item>
      <template v-if="info.certificatesType==2">
        <el-descriptions-item label="姓名">{{info.companyName}}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{info.code}}</el-descriptions-item>
        <el-descriptions-item label="身份证">
          <el-image style="width: 153px;"  :src="info.certificatesImg.split(',')[0]"
            :previewSrcList="info.certificatesImg.split(',')" fit="cover"></el-image>
          <el-image style="width: 153px;" class="ml10" :src="info.certificatesImg.split(',')[1]"
            :previewSrcList="info.certificatesImg.split(',')" fit="cover"></el-image>
        </el-descriptions-item>
      </template>

      <template v-if="info.certificatesType==1">
        <el-descriptions-item label="门店类型">{{getCompanyTypeName(info.companyType)}}</el-descriptions-item>
        <el-descriptions-item label="企业全称">{{info.companyName}}</el-descriptions-item>
        <el-descriptions-item label="资质类型">{{info.companyZiZhi==2?'医疗机构职业许可证':'营业执照'}}</el-descriptions-item>
        <el-descriptions-item label="统一社会信用代码">{{info.code}}</el-descriptions-item>
        <el-descriptions-item label="纳税人识别号">{{info.taxpayerCode}}</el-descriptions-item>
        <el-descriptions-item label="资质证件凭证">
          <el-image style="width: 153px;" :src="info.certificatesImg" :previewSrcList="[info.certificatesImg]"
            fit="cover"></el-image>
        </el-descriptions-item>
      </template>

    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="doCreate()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        formVisible: false,
        info: {}
      }
    },
    created() {

    },
  methods: {
    // 将门店类型数字转换为中文名称
    getCompanyTypeName(companyType) {
      const companyTypeMap = {
        0: '诊所',
        1: '私立医院',
        2: '卫生室',
        3: '单体店',
        4: '社区卫生服务站',
        5: '美容院'
      }
      // 如果传入的是字符串，直接返回；如果是数字，返回对应中文名称；否则返回原值
      if (typeof companyType === 'string' && isNaN(companyType)) {
        return companyType
      }
      const num = Number(companyType)
      return companyTypeMap[num] !== undefined ? companyTypeMap[num] : companyType
    },
    handleShow(row) {
      console.log('row: ', row);
      this.info = row
      this.formVisible = true

      this.$nextTick(() => {

      })
    },
      doCreate() {
        this.formVisible = false;
        this.$emit('created')
      },
    }
  }
</script>
<style lang="scss" scoped>
  .label {
    display: flex;
    margin-bottom: 26px;

    &>div {
      height: 40px;
      margin-right: 18px;
      // line-height: 40px;
    }

    .label-box {
      padding: 12px 24px;
      border-radius: 4px;
      border: 1px solid #D9D9D9
    }

    .label-active {
      border: 1px solid #60B7DC;
      background: #5DBDE733;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 54px;
    height: 54px;
    line-height: 62px;
  }

  ::v-deep .el-upload-list__item {
    width: 54px;
    height: 54px;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-cascader {
    width: 100%;
  }

  ::v-deep .el-dialog {
    max-height: 88vh;
    margin-top: 6vh !important;
  }

  ::v-deep .el-form {
    max-height: 64vh !important;
    overflow-y: auto;
  }

  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }

  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }

  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }

  ::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 54px;
    height: 54px;
    line-height: 54px;
    text-align: center;
  }

  .avatar {
    width: 54px;
    height: 54px;
    display: block;
  }

  .card-uploader img {
    height: 132px;
    width: 194px;
    margin-right: 56px;
  }
</style>
